import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import Dashboard from '../pages/dashboard/Dashboard.jsx'
import Login from '../pages/login/Login.jsx'
import { permissions } from '../utility/constants'
import Layout from '../layout/Layout.jsx'
import ResetPasswordForm from '../pages/login/ResetPasswordForm.jsx'
import ForgotPasswordInput from '../pages/login/ForgotPasswordInput.jsx'
import LoginWithPassword from '../pages/login/LoginWithPassword.jsx'
// !followup
import FollowupForm from '../pages/inquiry/followup/form/FollowupForm.jsx'
// !course
import ViewCourseList from '../pages/course/ViewCourseList.jsx'
// !branch
import Branch from '../pages/branch/Branch.jsx'
import BranchForm from '../pages/branch/form/BranchForm.js'
import { useSelector } from 'react-redux'
import ErrorBoundary from '../components/errorboundary/ErrorBoundary.jsx'
import NotFound from '../components/no-found/NoFound.jsx'
import { VerifyOtp } from '../pages/login/VerifyOtpForm.jsx'
import { getToken, removeUserSession } from '../utility/genricFunction.js'
import InquiryList from '../pages/inquiry/InquiryList.jsx'
import Faculty from '../pages/faculty/FacultyList.jsx'
import Enrollment from '../pages/enrollment/EnrollmentList.jsx'
import EnrollmentForm from '../pages/enrollment/form/NewEnrollmentForm.jsx'
import Timetable from '../pages/timetable/Timetable.jsx'
import FacultyForm from '../pages/faculty/form/FacultyForm.jsx'
import FacultySchedule from '../pages/faculty/dashboard/FacultySchedule.jsx'
import BillingHistory from '../pages/billing/BillingHistory.jsx'
import ExamResultMain from '../components/examassessment/ExamResultMain.jsx'
import StartAssessment from '../components/examassessment/StartAssessment.jsx'
import AddInquiryForm from '../pages/inquiry/Addinquiry.jsx'
import AddCourseInformation from '../pages/course/AddCourseInformation.jsx'
import AddCourseContent from '../pages/course/AddCourseContent.jsx'
import AddCoursePricing from '../pages/course/AddCoursePricing.jsx'
import FacultyExamAssessment from '../pages/exam-assessment/FacultyExamAssessment.jsx'
import StudentExam from '../components/student/StudentExam.jsx'
import StudentPractice from '../components/studentPracticeExam/StudentPractice.jsx'
import StudentExamTest from '../components/studentPracticeExam/StudentExamTest.jsx'
import StudentDashboard from '../pages/student-dashboard/StudentDashboard.jsx'
import StudentProfile from '../pages/StudentProfile/StudentProfile.jsx'
import StudentFees from '../pages/StudentFees/StudentFees.jsx'
import CourseDetails from '../pages/student-dashboard/course-details/CourseDetails.jsx'
import Inventory from '../pages/inventory/InventoryList.jsx'
import BillingInfo from '../pages/billing/BillingInfo.jsx'
import FacultyProfile from '../pages/facultyProfile/FacultyProfile.jsx'
import RoleManagement from '../pages/roleMangement/RoleManagement.jsx'
import UserManagement from '../pages/userManagement/UserManagement.jsx'
import AddNewRole from '../pages/roleMangement/AddNewRole.jsx'
import UserManagementForm from '../pages/userManagement/form/UserManagementForm.js'
import Configuration from '../pages/configuration/Configuration.jsx'
import TimeTableReport from '../pages/reports/Time Table/TimeTableReport.jsx'
import FeesCollection from '../pages/reports/Fees-collection/FeesCollection.jsx'
import StudentDetailsReport from '../pages/reports/student-details/StudentDetailsReport.jsx'
import AttendanceReport from '../pages/reports/attendance-report/AttendanceReport.jsx'
import ExamResultReport from '../pages/reports/examResult-report/ExamResultReport.jsx'
import FacultyLectureReport from '../pages/reports/facultyLacture-report/FacultyLectureReport.jsx'
import LectureCountReport from '../pages/reports/lectureCount-report/LectureCountReport.jsx'
import Placements from '../pages/placements/Placements.jsx'
import KitSummaryReport from '../pages/reports/KitSummary/KitSummaryReport.jsx'
import DailyReport from '../pages/reports/DailyReport/DailyReport.jsx'
import SourceWiseInquiryReport from '../pages/reports/SourceWiseInquiryReport/SourceWiseInquiryReport.jsx'
import KitDistributionReport from '../pages/reports/KitDistribution/KitDistributionReport.jsx'
import InquirySourceList from '../pages/inquirySourse/InquirySourceList.jsx'
import AreaWiseInquiryReport from '../pages/reports/AreaWiseInquiryReport/AreaWiseInquiryReport.jsx'
import InquiryReport from '../pages/reports/InquiryReport/InquiryReport.jsx'
import Banks from '../pages/MasterConfig/Banks/Banks.jsx'
import Designation from '../pages/MasterConfig/designation/Designation.jsx'
import AreaList from '../pages/MasterConfig/area/AreaList.jsx'
import EducationQualificationList from '../pages/MasterConfig/education-qualification/EducationQualificationList.jsx'
import { store } from '../store/store.js'
import PrivacyPolicy from '../pages/privacyPolicy/PrivacyPolicy.jsx'
import ContactUs from '../pages/contactUs/ContactUs.jsx'
import FeesCollectionDueReport from '../pages/reports/fees-collection-due/FeesCollectionDueReport.jsx'
import TotalFees from '../pages/fees/TotalFees'
import Batch from '../pages/batch/Batch.jsx'

const PublicRoute = ({ children }) => {
  const token = getToken()
  if (token && token?.accessToken) {
    return <Navigate to={'/dashboard'} />
  } else {
    return children
  }
}

const PrivateRoute = ({ children }) => {
  const token = getToken()
  const userData = useSelector((store) => store?.auth?.user?.result?.userData?.userPermission)

  if (userData.length && token && token?.accessToken) {
    return children
  } else {
    removeUserSession(store.dispatch);
    return <Navigate to={'/login'} />
  }
}
const CheckNavigation = () => {
  const token = getToken()
  if (token && token?.accessToken) {
    return <Navigate replace to='/dashboard' />
  } else {
    return <Navigate replace to='/login' />
  }
}

export const RoutesPage = () => {
  const userData = useSelector((store) => store?.auth?.user?.result?.userData?.userPermission)

  const roleBasedRouting = [
    {
      route: '/dashboard',
      role: ['admin'],
      permissions: permissions.ADMIN_DASHBOARD,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <Dashboard />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/dashboard',
      role: ['branch'],
      permissions: permissions.ADMIN_DASHBOARD,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <Dashboard />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/dashboard',
      role: ['inquiry'],
      permissions: permissions.ADMIN_DASHBOARD,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <Dashboard />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/dashboard',
      role: ['student'],
      permissions: permissions.STUDENT_DASHBOARD,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <StudentDashboard />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/dashboard',
      role: ['faculty'],
      permissions: permissions.FACULTY_DASHBOARD,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <FacultySchedule />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    ////////////////////
    {
      route: '/student-practice',
      role: ['student'],
      permissions: permissions.STUDENT_DASHBOARD,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <StudentPractice />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    //////////////////////////////////
    {
      route: '/student-exam-test',
      role: ['student'],
      permissions: permissions.STUDENT_DASHBOARD,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <StudentExamTest />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    ////////////////////////////////
    {
      route: '/course',
      role: ['admin', 'branch'],
      permissions: permissions.VIEW_COURSE,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <ViewCourseList />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/inquiry',
      role: ['admin', 'branch', 'inquiry'],
      permissions: permissions.VIEW_INQUIRY,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <InquiryList />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/faculty',
      role: ['admin', 'branch'],
      permissions: permissions.VIEW_FACULTY,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <Faculty />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/faculty/billing-info/:id',
      role: ['admin', 'branch'],
      permissions: permissions.BILLING_INFO,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <BillingInfo />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/enrollment',
      role: ['admin', 'branch'],
      permissions: permissions.VIEW_ENROLLMENT,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <Enrollment />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/enrollment/add-enrollment',
      role: ['admin', 'branch'],
      permissions: permissions.ENROLL_INQUIRY,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <EnrollmentForm />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/enrollment/edit-enrollment/:id',
      role: ['admin', 'branch'],
      permissions: permissions.EDIT_ENROLLMENT,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <EnrollmentForm />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/timetable',
      role: ['admin', 'branch', 'faculty'],
      permissions: permissions.VIEW_TIMETABLE,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <Timetable />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/attendance',
      role: ['admin', 'branch'],
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <Dashboard />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/student',
      role: ['admin', 'branch'],
      permissions: permissions.ADMIN_DASHBOARD,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <Dashboard />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    // {
    //   route: '/exam-assessment',
    //   role: ["faculty"],
    //   permissions:[permissions.VIEW_FACULTY_EXAM_ASSESSMENT],
    //   element: <PrivateRoute>
    //     <ErrorBoundary>
    //       <Layout>
    //         <ExamAssessment />
    //       </Layout>
    //     </ErrorBoundary>
    //   </PrivateRoute>
    // },
    {
      route: '/exam-assessment/result',
      role: ['faculty'],
      permissions: permissions.VIEW_EXAM_ASSESSMENT_RESULT,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <ExamResultMain />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/assessment',
      role: ['faculty'],
      permissions: permissions.VIEW_ASSESSMENT,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <StartAssessment />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/inventory',
      role: ['admin', 'branch'],
      permissions: permissions.VIEW_INVENTORY,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <Inventory />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/reports/time-table',
      role: ['admin'],
      permissions: permissions.VIEW_REPORTS,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <TimeTableReport />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/inquiry/followup/create/:id',
      role: ['admin', 'branch', 'inquiry'],
      permissions: permissions.TAKE_FOLLOW_UP,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <FollowupForm />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    // {
    //   route: '/inquiry/followup/edit',
    //   role: ["admin", "branch", "inquiry"],
    //   element: <PrivateRoute>
    //     <ErrorBoundary>
    //       <Layout>
    //         <FollowupForm />
    //       </Layout>
    //     </ErrorBoundary>
    //   </PrivateRoute>
    // },
    {
      route: '/branch',
      role: ['admin', 'branch'],
      permissions: permissions.VIEW_BRANCH,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <Branch />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    // {
    //   route: '/view-course',
    //   role: ["admin", "branch"],
    //   element: <PrivateRoute>
    //     <ErrorBoundary>
    //       <Layout>
    //         <ViewCourseList />
    //       </Layout>
    //     </ErrorBoundary>
    //   </PrivateRoute>
    // },
    {
      route: '/branch/add-branch',
      role: ['admin', 'branch'],
      permissions: permissions.ADD_BRANCH,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <BranchForm />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/branch/:id',
      role: ['admin', 'branch'],
      permissions: permissions.EDIT_BRANCH,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <BranchForm />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/course/add-course/information',
      role: ['admin', 'branch'],
      permissions: permissions.ADD_COURSE,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <AddCourseInformation />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/course/edit-course/information/:id',
      role: ['admin', 'branch'],
      permissions: permissions.EDIT_COURSE,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <AddCourseInformation />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/student-profile',
      role: ['student'],
      permissions: permissions.VIEW_STUDENT_PROFILE,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <StudentProfile />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    // {
    //   route: '/student-timetable',
    //   role: ["student"],
    //   element: <PrivateRoute>
    //     <ErrorBoundary>
    //       <Layout>
    //         <Dashboard />
    //       </Layout>
    //     </ErrorBoundary>
    //   </PrivateRoute>
    // },
    {
      route: '/student-fees',
      role: ['student'],
      permissions: permissions.VIEW_STUDENT_FEES,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <StudentFees />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/dashboard/course-details/:id',
      role: ['student'],
      permissions: permissions.VIEW_COURSE_DETAIL,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <CourseDetails />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/student-exam',
      role: ['student'],
      permissions: permissions.VIEW_STUDENT_EXAM,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <StudentExam />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/exam-assessment/faculty',
      role: ['faculty'],
      permissions: permissions.VIEW_FACULTY_EXAM_ASSESSMENT,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <FacultyExamAssessment />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/faculty/add-faculty',
      role: ['admin', 'branch'],
      permissions: permissions.ADD_FACULTY,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <FacultyForm />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/faculty/edit-faculty/:id',
      role: ['admin', 'branch'],
      permissions: permissions.EDIT_FACULTY,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <FacultyForm />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/billing-history',
      role: ['faculty'],
      permissions: permissions.BILLING_HISTORY,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <BillingHistory />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/faculty-profile',
      role: ['faculty'],
      permissions: permissions.VIEW_FACULTY_PROFILE,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <FacultyProfile />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/placements',
      role: ['admin', 'branch'],
      permissions: permissions.ADMIN_DASHBOARD,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <Placements />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/inquiry/new-inquiry',
      role: ['admin', 'branch', 'inquiry'],
      permissions: permissions.ADD_INQUIRY,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <AddInquiryForm />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/inquiry/new-inquiry/T2W/:id',
      role: ['admin', 'branch', 'inquiry'],
      permissions: permissions.MOVE_TO_WALKIN,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <AddInquiryForm />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/inquiry/edit-inquiry/:id',
      role: ['admin', 'branch', 'inquiry'],
      permissions: permissions.EDIT_INQUIRY,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <AddInquiryForm />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/course/add-course/content',
      role: ['admin', 'branch'],
      permissions: permissions.ADD_COURSE,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <AddCourseContent />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/course/edit-course/content/:id',
      role: ['admin', 'branch'],
      permissions: permissions.EDIT_COURSE,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <AddCourseContent />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/course/add-course/pricing',
      role: ['admin', 'branch'],
      permissions: permissions.ADD_COURSE,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <AddCoursePricing />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/course/add-course/pricing/:id',
      role: ['admin', 'branch'],
      permissions: permissions.EDIT_COURSE,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <AddCoursePricing />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/exam-assessment/faculty/result/:timetableId',
      permissions: permissions.FACULTY_DASHBOARD,
      role: ['faculty'],
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <ExamResultMain />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/role-management',
      role: ['admin'],
      permissions: permissions.VIEW_ROLE,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <RoleManagement />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/role-management/add-role',
      role: ['admin'],
      permissions: permissions.ADD_ROLE,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <AddNewRole />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/role-management/:id',
      role: ['admin'],
      permissions: permissions.EDIT_ROLE,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <AddNewRole />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/user-management',
      role: ['admin'],
      permissions: permissions.VIEW_USERS,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <UserManagement />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/user-management/add-user',
      role: ['admin'],
      permissions: permissions.ADD_USER,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <UserManagementForm />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/user-management/edit-user/:id',
      role: ['admin'],
      permissions: permissions.EDIT_USER,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <UserManagementForm />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/configuration',
      permissions: permissions.VIEW_CONFIGURATION,
      role: ['admin'],
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <Configuration />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/reports/fees-outstanding-report',
      permissions: permissions.VIEW_DUE_COLLECTION,
      role: ['admin', 'branch'],
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <TotalFees />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/reports/kit-summary',
      role: ['admin'],
      permissions: permissions.VIEW_REPORTS,

      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <KitSummaryReport />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/reports/daily-report',
      role: ['admin'],
      permissions: permissions.VIEW_REPORTS,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <DailyReport />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/manage-batch/:branchId',
      role: ['admin', 'branch'],
      permissions: permissions.MANAGE_BATCH,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <Batch />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/reports/source-wise-inquiry',
      role: ['admin'],
      permissions: permissions.VIEW_REPORTS,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <SourceWiseInquiryReport />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/reports/kit-distribution',
      role: ['admin'],
      permissions: permissions.VIEW_REPORTS,
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <KitDistributionReport />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/reports/feesCollection-report',
      permissions: permissions.VIEW_REPORTS,
      role: ['admin', 'branch'],
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <FeesCollection />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/reports/feesCollectionDue-report',
      permissions: permissions.VIEW_REPORTS,
      role: ['admin', 'branch'],
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <FeesCollectionDueReport />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/reports/areawise-inquiry-report',
      permissions: permissions.VIEW_REPORTS,
      role: ['admin', 'branch'],
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <AreaWiseInquiryReport />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/reports/studentDetails-report',
      permissions: permissions.VIEW_REPORTS,
      role: ['admin', 'branch'],
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <StudentDetailsReport />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/reports/attendance-report',
      permissions: permissions.VIEW_REPORTS,
      role: ['admin', 'branch'],
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <AttendanceReport />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/reports/examResult-report',
      permissions: permissions.VIEW_REPORTS,
      role: ['admin', 'branch'],
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <ExamResultReport />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/reports/facultyLecture-report',
      permissions: permissions.VIEW_REPORTS,
      role: ['admin', 'branch'],
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <FacultyLectureReport />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/reports/lectureCount-report',
      permissions: permissions.VIEW_REPORTS,
      role: ['admin', 'branch'],
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <LectureCountReport />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/reports/inquiry-report',
      permissions: permissions.VIEW_REPORTS,
      role: ['admin', 'branch'],
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <InquiryReport />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/master/inquirySource',
      permissions: permissions.VIEW_INQUIRY,
      role: ['admin'],
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <InquirySourceList />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/master/Banks',
      permissions: permissions.VIEW_INQUIRY,
      role: ['admin'],
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <Banks />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/master/Designation',
      permissions: permissions.VIEW_INQUIRY,
      role: ['admin'],
      element: (
        <PrivateRoute>
          <ErrorBoundary>
            <Layout>
              <Designation />
            </Layout>
          </ErrorBoundary>
        </PrivateRoute>
      ),
    },
    {
      route: '/master/area-list',
      permissions: permissions.VIEW_REPORTS,
      role: ["admin", "branch"],
      element: (
      <PrivateRoute>
        <ErrorBoundary>
          <Layout>
            <AreaList />
        </Layout>
        </ErrorBoundary>
      </PrivateRoute>
      ),
    },
    {
      route: '/master/education-qualification',
      permissions: permissions.VIEW_REPORTS,
      role: ["admin", "branch"],
      element: (
      <PrivateRoute>
        <ErrorBoundary>
          <Layout>
            <EducationQualificationList />
        </Layout>
        </ErrorBoundary>
      </PrivateRoute>
      )
    },
  
  ]

  const token = getToken()
  return (
    <Router>
      <Routes>
        <Route path='*' element={!token?.accessToken ? <Navigate to='/login' replace /> : <NotFound />} />

        <Route path='/' element={CheckNavigation()} />

        <Route
          path='/login'
          element={
            <PublicRoute>
              <ErrorBoundary>
                <Login />
              </ErrorBoundary>
            </PublicRoute>
          }
        />
        <Route
          path='/login-email'
          element={
            <PublicRoute>
              <ErrorBoundary>
                <LoginWithPassword />
              </ErrorBoundary>
            </PublicRoute>
          }
        />
        <Route
          path='/login-with-password'
          element={
            <PublicRoute>
              <ErrorBoundary>
                <LoginWithPassword />
              </ErrorBoundary>
            </PublicRoute>
          }
        />
        <Route
          path='/verify-otp'
          element={
            <PublicRoute>
              <ErrorBoundary>
                <VerifyOtp />
              </ErrorBoundary>
            </PublicRoute>
          }
        />
        <Route
          path='/reset-password'
          element={
            <PublicRoute>
              <ErrorBoundary>
                <ResetPasswordForm />
              </ErrorBoundary>
            </PublicRoute>
          }
        />
        <Route
          path='/forgot-password'
          element={
            <PublicRoute>
              <ErrorBoundary>
                <ForgotPasswordInput />
              </ErrorBoundary>
            </PublicRoute>
          }
        />
        <Route
          path='/privacy-policy'
          element={
              <ErrorBoundary>
                <PrivacyPolicy />
              </ErrorBoundary>
          }
        />
         <Route
          path='/contact-us'
          element={
              <ErrorBoundary>
                <ContactUs />
              </ErrorBoundary>
          }
        />
        {roleBasedRouting
          .filter((data) => userData?.includes(data.permissions))
          .map((data) => {
            return <Route key={data.route} path={data.route} element={{ ...data.element }} />
          })}
      </Routes>
    </Router>
  )
}
